import type { LucideIcon } from 'lucide-vue-next'
import type { defineAsyncComponent } from 'vue'

/**
 * Represents the different types of dynamic modals.
 */
export enum DynamicModalType {
	Default = '',
	Login = 'login',
	RegisterSuccess = 'register_success',
	ForgotPassword = 'forgot_password',
	Settings = 'settings',
	LockedFeature = 'locked_feature',
	CheckoutPremium = 'checkout_premium',
	PurchaseHistory = 'purchases_history',
	AvatarEdit = 'avatar_edit',
	Community = 'community',
	MyPrompts = 'my_searches',
	Subscription = 'subscription',
	UpdateLocale = 'update_locale',
	DeleteImage = 'delete_image',
	UpscaleImage = 'upscale_image',
	SelectGenStyle = 'select_gen_style',
	SelectFilterStyles = 'select_filter_styles',
	AllAchievements = 'all_chievements',
	DuplicateImage = 'duplicate_image',
	AccountSetup = 'account_setup',
	GeneratorModifiers = 'generator_modifiers',
	G2AGuide = 'g2a_guide',
	ProExpired = 'pro_expired',
	RedeemConflicts = 'redeem_conflicts',
	ConfirmCrypto = 'conf_crypto',
	NoStyleSelected = 'no_style_selected',
	ProRequired = 'pro_required',
}

export type ComponentType = ReturnType<typeof defineAsyncComponent>

export interface DynamicModalShortcut {
	label: (() => string) | string
	desktop: (() => string) | string
	mobile: (() => string) | string
}

export interface ComponentOptions {
	props?: Record<string, any>
	title?: string | (() => string)
	subtitle?: string | (() => string)
	icon?: LucideIcon | string | null
	// default to DynamicModalTheme.Auto
	theme?: DynamicModalTheme
	blockBodyScroll?: boolean
	shortcuts?: DynamicModalShortcut[]
	closable?: boolean
}
export interface ComponentRegistration {
	importCb: () => Promise<any>
	type: DynamicModalType
	data?: ComponentOptions
}

export interface MountedComponent {
	component: ComponentType
	type: DynamicModalType
	data: ComponentOptions
}

export enum DynamicModalTheme {
	Auto = '',
	Borderless = '-borderless',
	Fullscreen = '-fs',
	Large = '-large',
}
